__turbopack_context__.v({
  "barButton": "TRLm7q_barButton",
  "bookingInfo": "TRLm7q_bookingInfo",
  "bottomBarContainer": "TRLm7q_bottomBarContainer",
  "buttonRow": "TRLm7q_buttonRow",
  "cartItemCount": "TRLm7q_cartItemCount",
  "cartOriginalTotal": "TRLm7q_cartOriginalTotal",
  "cartTotal": "TRLm7q_cartTotal",
  "desktopRow": "TRLm7q_desktopRow",
  "mobileColumn": "TRLm7q_mobileColumn",
  "mobileTopRow": "TRLm7q_mobileTopRow",
  "rightGroup": "TRLm7q_rightGroup",
  "slideUp": "TRLm7q_slideUp",
});
